import * as CouponRateActions from 'actions/CouponRate';
import * as HistoryBetActions from 'actions/HistoryBet';
import * as MakeBetActions from 'actions/MakeBet';
import * as possibleBetTypes from 'constants/BetType';
import * as StorageActions from 'actions/Storage';

const initialState = -1;

export default function currentBetTypeReducer(currentBetTypeIndex, betTypes, isBetTypeSelected, action) {
    if (currentBetTypeIndex === undefined) {
        return initialState;
    }

    switch (action.type) {
        case StorageActions.LOAD_STORAGE:
            const betTypeIndex = action.data.betTypeIndex;
            if (betTypeIndex !== undefined && betTypeIndex !== null) {
                currentBetTypeIndex = betTypeIndex;
            }
            break;

        case CouponRateActions.SET_COUPON_BET_TYPE:
            return action.data;

        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
            if (!isBetTypeSelected || !betTypes.has(currentBetTypeIndex)) {
                currentBetTypeIndex = betTypes.indexOf(fetchExpressBetType(betTypes));

                if (currentBetTypeIndex === -1 || betTypes.size === 1) {
                    currentBetTypeIndex = betTypes.indexOf(betTypes.first());
                }
            }

            return currentBetTypeIndex;

        case CouponRateActions.REMOVE_COUPON_RATES:
            //case MakeBetActions.MAKE_BET:
            return -1;

        case MakeBetActions.SUCCESS_MAKE_BET:
            const createdBets = action.data;
            let rateBlockNum = 0;

            for (let offset = 0; offset < createdBets.length; offset++) {
                const createdBet = createdBets[offset];

                if (createdBet.error !== undefined && createdBet.error) {
                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
                        rateBlockNum++;
                    }
                    if(createdBet.error === -18){
                        rateBlockNum++;
                    }
                }
            }

            return (rateBlockNum === 0) ? initialState : currentBetTypeIndex;

        case MakeBetActions.FAILURE_MAKE_BET:
            return initialState;

        case CouponRateActions.ACCEPT_RATE_VALUE_CHANGE:
            return currentBetTypeIndex;
    }

    return currentBetTypeIndex;
}

function fetchExpressBetType(betTypes) {
    if (!betTypes) {
        return -1;
    }

    const betTypeCollection = betTypes.toArray();
    let defaultBetType = -1;

    for (let offset in betTypeCollection) {
        if (betTypeCollection[offset].type == possibleBetTypes.EXPRESS) {
            defaultBetType = betTypeCollection[offset];
            break;
        }
    }

    return defaultBetType;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/currentBetTypeReducer.js